import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AdminService} from '../../../services/admin.service';
import {Standard} from '../../../models/standard.model';
import {ApiConnectService} from '../../../services/api-connect.service';
import {UserService} from '../../../services/user.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ViewDocxService} from '../../../services/view-docx.service';
import {ViewDocxComponent} from '../../views/view-docx/view-docx.component';

@Component({
  selector: 'app-translate-standard',
  templateUrl: './translate-standard.component.html',
  styleUrls: ['./translate-standard.component.css']
})
export class TranslateStandardComponent implements OnInit {

  public isLoaded = false;                         // Show spinner while standard is loading
  public errorMsg = false;                         // Show error message if we can't get standard
  public urlID = '';                               // Get standard ID from URL. Example:
  // http://localhost/translate-standard/5ae194734db9cf5918f9f8ce
  public standard = null;                          // Save here standard for translate
  public showCancelBtn = true;                     // Show Cancel button if URL includes 'translate-standard/'
  public standardBaseLanguage = '';                // Save here base standard language
  formData: FormData = new FormData();              // FormData for uploading files
  public disableDoneBtn = false;                   // Make Translate btn. disabled after click
  public showSuccessMsg = false;                   // Show message if Standard successfully translated
  public showErrorMsg = false;                     // Show message if Standard translated with error
  public clearStatus = '';
  public isDocFileValid = false;
  public invalidDataMsg = false;

  constructor(private route: ActivatedRoute,
              private adminService: AdminService,
              private router: Router,
              public viewDocxService: ViewDocxService,
              private modalService: NgbModal,
              private apiConnectService: ApiConnectService,
              private userService: UserService) {
  }

  ngOnInit() {
    this.isDocFileValid = false;
    this.isLoaded = false;
    this.errorMsg = false;
    this.standardBaseLanguage = '';
    this.disableDoneBtn = false;
    this.showSuccessMsg = false;
    this.showErrorMsg = false;
    this.invalidDataMsg = false;

    this.urlID = this.route.snapshot.params['id'];

    this.showCancelBtn = this.router.url.includes('translate-standard/');

    this.adminService.getStandardTranslate(this.urlID).subscribe(
      (res: any) => {

        if (res.status === 200) {
          this.standard = res.body;
          // Get standard base language by standard ID
          this.standardBaseLanguage = this.standard.language;

          // Replace _ char
          this.clearStatus = this.standard.status;
          const replaceChar = /\_/gi;
          const result = this.clearStatus.replace(replaceChar, ' ');
          this.standard.status = result;
          this.errorMsg = false;
        } else {
          this.errorMsg = true;
        }

        this.isLoaded = true;
      },
      () => {
        this.errorMsg = true;
        this.isLoaded = true;
      }
    );
  }


  openDocModal(docxID, sID) {
    localStorage.setItem('DocxID', docxID);
    localStorage.setItem('DocxSID', sID);

    const modalRef = this.modalService.open(ViewDocxComponent, {size: 'lg', backdrop: 'static'});
    modalRef.result.then((result) => {
      if (result === 'Close') {
        // on close button
        this.viewDocxService.deleteLinkByDocxID();
      }
    }, (reason) => {
      // on dismiss
      this.viewDocxService.deleteLinkByDocxID();
    });

  }

  openDocModalDOCX(fileLink) {
    localStorage.setItem('fileLink', fileLink);

    const modalRef = this.modalService.open(ViewDocxComponent, {size: 'lg', backdrop: 'static'});
    modalRef.result.then((result) => {
      if (result === 'Close') {
        // on close button
        this.viewDocxService.deleteLinkByDocxIDManually();
      }
    }, (reason) => {
      // on dismiss
      this.viewDocxService.deleteLinkByDocxIDManually();
    });

  }


  // Use it for validation all fields on other language
  isValidFields() {
    if (this.isLoaded) {

      // For russian language
      if (this.standardBaseLanguage.toLowerCase() === 'russian') {
        return (this.standard.enName !== null && this.standard.enName !== ''
          && this.standard.enAnnotation !== null && this.standard.enAnnotation !== ''
          && this.isDocFileValid);

        // For english language
      } else if (this.standardBaseLanguage.toLowerCase() === 'english') {
        return (this.standard.ruName !== null && this.standard.ruName !== ''
          && this.standard.ruAnnotation !== null && this.standard.ruAnnotation !== ''
          && this.isDocFileValid);

      }
    }
  }


  translateStandardMainInfo() {
    this.invalidDataMsg = false;
    if (this.isValidFields()) {

      this.disableDoneBtn = true;
      this.showSuccessMsg = false;
      this.showErrorMsg = false;


      const dataStandard = {
        id: this.standard.id,
        number: null,
        authorId: null,
        groupId: null,
        status: this.clearStatus,
        standardType: {
          id: this.standard.standardType.id,
          ruName: this.standard.standardType.ruName,
          enName: this.standard.standardType.enName
        },
        standardDisseminationPositions: [],
        ruName: this.standard.ruName,
        ruAnnotation: this.standard.ruAnnotation,
        enName: this.standard.enName,
        enAnnotation: this.standard.enAnnotation,
        language: this.standard.language
      };


      // TODO сделать загрузку файлов, а потом перевод станларта
      this.adminService.doneStandardMainInfo(this.urlID, dataStandard).subscribe(
        (res: any) => {

          if (res.status === 200) {
            this.uploadFiles();
          } else {
            this.disableDoneBtn = false;
            this.showSuccessMsg = false;
            this.showErrorMsg = true;
          }
        },
        () => {
          this.disableDoneBtn = false;
          this.showSuccessMsg = false;
          this.showErrorMsg = true;
        }
      );

    } else {
      // Show validation data error message
      this.invalidDataMsg = true;
    }
  }

  // Go to home page
  onCancelAction() {
    this.router.navigate(['/dashboard/home']);
  }

  // Open .PDF file in new browser tab
  openPDFFile(fileId: string) {
    window.open(this.apiConnectService.getPdf + fileId, '_blank');
  }

  // Download presentation file from server by ID
  downloadPPTXFile(fileId: string) {
    this.userService.getFile(fileId).subscribe(
      (response: any) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.body);
        link.download = response.headers.get('filename');
        link.click();
        link.remove();
      },
      () => {
      }
    );
  }

  // Select files for uploading
  fileChange(type: string, event) {
    const fileList = event.target.files;

    console.warn(fileList);

    if (fileList.length > 0) {
      const file: File = fileList[0];
      this.formData.set(type, file, file.name);

      // Validation actions
      if (this.standardBaseLanguage.toLowerCase() === 'russian') {
        this.isDocFileValid = this.formData.has('EN_DOC');
      } else if (this.standardBaseLanguage.toLowerCase() === 'english') {
        this.isDocFileValid = this.formData.has('RU_DOC');
      }
    } else {
      this.formData.delete(type);
      // Validation actions
      if (type === 'RU_DOC' || type === 'EN_DOC') {
        this.isDocFileValid = false;
      }
    }
  }

  // Upload files from formData
  private uploadFiles() {
    this.adminService.uploadFiles(this.standard, this.formData).subscribe(
      (res: any) => {

        if (res.status === 200) {
          this.showSuccessMsg = true;
          this.showErrorMsg = false;
        } else {
          this.showSuccessMsg = false;
          this.showErrorMsg = true;
        }
        this.disableDoneBtn = false;
      },
      () => {
        this.disableDoneBtn = false;
        this.showSuccessMsg = false;
        this.showErrorMsg = true;
      }
    );
  }

}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/translate/translate-standard/translate-standard.component.ts